export enum DutyMutationTypeEnum {
  DELETE = 'delete',
  UNLINK = 'unlink',
  ADD = 'add'
}

export type DutyMutationType = 'delete' | 'unlink' | 'add';

export type MutateDutyLinesInBulkParams = {
  employeeId: number;
  isEmployeePortal: boolean;
  dutyLineIds: number[];
  type: DutyMutationType;
  flags?: string[];
};
